export var PurchaseSituation;
(function (PurchaseSituation) {
    PurchaseSituation["ContractsExchanged"] = "CONTRACTS_EXCHANGED";
    PurchaseSituation["OfferMade"] = "OFFER_MADE";
    PurchaseSituation["BuyingSoon"] = "BUYING_SOON";
    PurchaseSituation["ExploringOptions"] = "EXPLORING_OPTIONS";
    PurchaseSituation["ActivelyLookingForAHome"] = "ACTIVELY_LOOKING_FOR_A_HOME";
})(PurchaseSituation || (PurchaseSituation = {}));
//# sourceMappingURL=index.js.map